import { Button, colors, ControlledRadioGroup, Modal, ModalHeader, Typography } from '@ui-components/neo.tax';
import { ReactComponent as InfoIcon } from '@ui-components/neo.tax/dist/icons/info-circle.svg';
import { ReactElement } from 'react';
import { useForm } from 'react-hook-form';

import { CapitalizableProjectClusteringOverride } from '@neo.tax/shared';

import { StyledFooter } from './batch-update-capitalizable-project-clustering-modal.styled';

type FormValues = { override: CapitalizableProjectClusteringOverride };

const OVERRIDE_OPTIONS = [
  {
    id: 'override-include',
    value: CapitalizableProjectClusteringOverride.Included,
    label: 'Include',
    description: 'Match capitalizable tickets to the selected projects on next sync.',
  },
  {
    id: 'override-exclude',
    value: CapitalizableProjectClusteringOverride.Excluded,
    label: 'Exclude',
    description: 'The selected projects will not receive capitalizable tickets on next sync.',
  },
];

type BatchUpdateCapitalizableProjectClusteringModalProps = {
  isOpen: boolean;
  count: number;
  loading: boolean;
  onClose: () => void;
  onSubmit: (override: CapitalizableProjectClusteringOverride) => void;
};

export const BatchUpdateCapitalizableProjectClusteringModal = ({
  count,
  isOpen,
  loading,
  onClose,
  onSubmit,
}: BatchUpdateCapitalizableProjectClusteringModalProps): ReactElement => {
  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: { override: CapitalizableProjectClusteringOverride.Included },
  });

  const submit = handleSubmit(({ override }) => onSubmit(override));

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose}>
      <ModalHeader
        icon={<InfoIcon width={24} color={colors.blue[600]} />}
        iconBgColor={colors.blue[50]}
        title={
          <Typography fontSize="base" fontWeight="semibold">
            Update Next Sync Matching
          </Typography>
        }
        copy={`Set next sync matching for the selected ${count} project${count === 1 ? '' : 's'}.`}
      />
      <form onSubmit={submit}>
        <ControlledRadioGroup<CapitalizableProjectClusteringOverride, FormValues>
          control={control}
          name="override"
          id="batch-update-matching-override"
          label="Matching"
          options={OVERRIDE_OPTIONS}
        />
        <StyledFooter>
          <Button disabled={loading} variant="white" rounded="regular" size="base" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={loading} variant="primary" rounded="regular" size="base" type="submit">
            Submit
          </Button>
        </StyledFooter>
      </form>
    </Modal>
  );
};
